<template>
  <div class="view-login">
    <p>Acesse sua conta</p>
    <form>
      <form-group
        v-model="form.email"
        id="email"
        label="Login"
        type="email"
        icon="fa-regular fa-user"
        placeholder="Digite seu e-mail"
        :errors="errors.email"
        @setError="setError"
        autoCheck
        ref="formEmail"
      />

      <form-group
        v-model="form.password"
        id="password"
        icon="fa-regular fa-search"
        label="Senha"
        type="password"
        placeholder="Digite sua senha"
        :errors="errors.password"
        @setError="setError"
        autoCheck
        disableAutocapitalize
        disableAutocomplete
        ref="formPassword"
      />
      <p class="text-right fs-14 mb-0">
        <router-link :to="{ name: 'forgot-password' }" style="color: #c7c7c7;">
          Esqueci minha senha
        </router-link>
      </p>

      <auth-button
        text="Acessar sua conta"
        class="text-center pt-9 mb-5"
        :loading="loading"
        :disabled="loading"
        @click="submit"
      />
    </form>

    <hr />

    <p class="text-center text-white fs-16">
      <router-link class="main" :to="{ name: 'register' }" @click="register">
        Criar nova conta
      </router-link>
    </p>

    <div class="footer fs-14">
      Este site é protegido por reCAPTCHA e a
      <a target="_blank" href="https://policies.google.com/privacy"
        >Política de Privacidade</a
      >
      e os
      <a target="_blank" href="https://policies.google.com/terms"
        >Termos de Serviço</a
      >
      do Google se aplicam.
    </div>
  </div>
</template>

<script>
import AuthButton from "@/components/auth/AuthButton.vue";
import { formFields } from "@/functions/helpers.js";

export default {
  components: { AuthButton },
  name: "login",
  data() {
    return {
      ...formFields(["email", "password"]),
      loading: false
    };
  },
  methods: {
    setError(error, field) {
      this.errors[field] = error;
    },
    register() {
      this.$dataLayer.push({
        event: "select_content"
      });
    },
    submit() {
      this.$message.hide();
      this.loading = true;

      this.$refs.formEmail.blur();
      this.$refs.formPassword.blur();

      window.grecaptcha
        .execute({ action: "submit" })
        .then(token => {
          this._submit(token);
        })
        .catch(() => {
          this.loading = false;
          this.$message.error("Por favor, tente novamente");
        });
    },
    _submit(recaptcha_token) {
      this.$store
        .dispatch("user/login", {
          ...this.form,
          recaptcha_token
        })
        .then(response => {
          this.$store.dispatch("postLogin").catch(() => {
            this.$router.replace({
              name: "login",
              query: { path: this.$route.fullPath }
            });
          });
          if (this.$route.query.path) {
            this.$router.push(this.$route.query.path);
          } else {
            this.$router.push({ name: "home" });
          }
          this.$dataLayer.push({
            event: "login",
            name: response.name,
            email: response.email
          });
        })
        .catch(error => {
          if (!error.response.data.non_field_errors) {
            Object.keys(error.response.data).forEach(field => {
              this.errors[field] = error.response.data[field];
            });
          } else {
            this.$message.error(error.response.data.non_field_errors[0]);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.view-login {
  hr {
    width: 25%;
    margin-bottom: 32px;
    margin-top: 48px;
    border-top: 2px solid var(--semantic-neutral-700, #d5d5d5);
    @media screen and (max-width: 1280px) {
      margin-bottom: 24px;
      margin-top: 32px;
    }
  }
  .footer {
    margin-top: 50px;
    text-align: center;
    font-size: 16px;
    color: var(--semantic-neutral-600, #c7c7c7);
    a {
      color: #fff;
    }
    @media screen and (max-width: 1280px) {
      margin-top: 25px;
    }
  }
}
</style>
